/*
 * @Author: yongwenhao
 * @Date: 2020-04-07 10:35:22
 * @describe: 服务内容数据
 */
let lang = sessionStorage.getItem('language') || 'zh';
const serviceData = {
    zh: {
        dm: {
            bannerContent: {
                src: require('../assets/service/service1.png'),
                title: '数据管理',
                content: "具有丰富的国内外临床试验的数据管理经验，由具有英、日、韩等多语言的专业人员组成。",
            },
            listData: [
                {
                    title: '数据管理',
                    content: `数据管理的目的是确保临床试验中所得到数据的可靠性、完整性、准确性以及统计分析前数据是合理的。质量源于设计，数据的可靠性首先基于科学的试验方案和病例报告表设计，其次需要完善的质量管理体系和规范化数据管理的保证，同时数据管理人员必须受到严格的GCP和数据管理相关法规的培训，而应用于数据采集和数据管理的电子数据采集系统或数据管理系统必须是通过验证并满足FDA 21 CFR part 11和NMPA《临床试验的电子数据采集技术指导原则》的要求。美达临床数据的数据管理团队严格遵循ICH-GCP、CDISC标准及临床试验的相关法规为客户提供专业化、高质量的服务，在欧美、日本及国内的临床试验数据管理上具有丰富的经验。团队主要成员具有优秀的英语、日语等语言沟通能力，能与国内外的客户进行有效的沟通交流。 `,
                    pic: require('../assets/service/1.png'),
                    index: 1
                }
            ],
            helpData: [
                {
                    title: '',
                    list: [
                        {
                            title: '数据管理咨询'
                        },
                        {
                            title: 'CRF设计和审核、注释CRF、CRF填写指南的撰写'
                        },
                        {
                            title: '数据库设计和创建'
                        },
                        {
                            title: '数据管理计划和报告的撰写'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: '数据核查计划的撰写'
                        },
                        {
                            title: '数据录入和比较'
                        },
                        {
                            title: '数据核查和清理'
                        },
                        {
                            title: '质疑的生成/解决'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: '方案偏离的管理'
                        },
                        {
                            title: '严重不良事件的一致性核查'
                        },
                        {
                            title: '外部数据的一致性核查'
                        },
                        {
                            title: '医学编码'
                        },
                        {
                            title: '数据审核会议的支持'
                        },
                        {
                            title: '数据质量稽查'
                        }
                    ]
                }
            ],
            areaData: [
                {
                    title: '',
                    list: [
                        {
                            title: '五官科'
                        },
                        {
                            title: '骨科'
                        },
                        {
                            title: '呼吸系统'
                        },
                        {
                            title: '心理学跟精神'
                        },
                        {
                            title: '抗感染药物/抗病毒药物/疫苗'
                        },
                        {
                            title: '口腔科'
                        },
                        {
                            title: '泌尿系统'
                        },
                        {
                            title: '内分泌'
                        },
                        {
                            title: '胃肠道和肝脏病'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: '生殖学/性健康/妇女健康'
                        },
                        {
                            title: '皮肤病'
                        },
                        {
                            title: '医疗器械和诊断业务'
                        },
                        {
                            title: '神经系统'
                        },
                        {
                            title: '食品'
                        },
                        {
                            title: '心脑血管'
                        },
                        {
                            title: '血液'
                        },
                        {
                            title: '眼科'
                        },
                        {
                            title: '疼痛/麻醉'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: '医美'
                        },
                        {
                            title: '肿瘤'
                        },
                        {
                            title: '免疫'
                        },
                        {
                            title: '代谢紊乱；代谢障碍'
                        },
                        {
                            title: '风湿病/炎症'
                        },
                        {
                            title: '药物代谢动力学'
                        },
                        {
                            title: '四期介入性研究'
                        },
                        {
                            title: '四期观察性研究'
                        },
                        {
                            title: '其他'
                        },
                    ]
                },
            ],
        },
        biostatistics: {
            bannerContent: {
                src: require('../assets/service/service2.png'),
                title: '生物统计',
                content: "具有丰富的国内外临床试验的生物统计经验，由具有英、日、韩等多语言的专业人员组成。",
            },
            listData: [
                {
                    title: '生物统计',
                    content: `生物统计团队由行业知名统计专家及多位资深统计师组成，从研究设计、实施、到研究结果交付的每一步流程中均可提供专业的统计支持。我们具备完善的质量保证体系和标准操作规程，熟悉并遵循统计相关的药政法规要求，致力于为医药研发提供高质量全方位的统计服务。
                    我们的统计团队具有丰富的经验，包括：                     
<p style="color: #435ba1">- 创新药物临床试验 
- 生物等效性临床试验 
- 数据监查委员会 (DMC) 支持 
- 观察性研究或非干预性研究 
- 生物类似药 
- 医疗器械<p/>`,
                    pic: require('../assets/service/2.png'),
                    index: 2
                }
            ],
            helpData: [
                {
                    title: '',
                    list: [
                        {
                            title: '统计咨询'
                        },
                        {
                            title: '方案撰写和审核',
                        },
                        {
                            title: '随机化'
                        },
                        {
                            title: 'CRF审核'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: '数据核查计划书的审核'
                        },
                        {
                            title: '统计分析计划及报告的撰写'
                        },
                        {
                            title: '制表/列表/图表的生成'
                        },
                        {
                            title: '统计分析'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: '统计监查'
                        },
                        {
                            title: '临床研究报告的建议和审核'
                        },
                        {
                            title: '数据监查委员会（DMC）支持'
                        },
                        {
                            title: '锁库前数据审核'
                        },
                        {
                            title: '揭盲'
                        }
                    ]
                }
            ],
            areaData: [
                {
                    title: '',
                    list: [
                        {
                            title: '五官科'
                        },
                        {
                            title: '骨科'
                        },
                        {
                            title: '呼吸系统'
                        },
                        {
                            title: '心理学跟精神'
                        },
                        {
                            title: '抗感染药物/抗病毒药物/疫苗'
                        },
                        {
                            title: '口腔科'
                        },
                        {
                            title: '泌尿系统'
                        },
                        {
                            title: '内分泌'
                        },
                        {
                            title: '胃肠道和肝脏病'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: '生殖学/性健康/妇女健康'
                        },
                        {
                            title: '皮肤病'
                        },
                        {
                            title: '医疗器械和诊断业务'
                        },
                        {
                            title: '神经系统'
                        },
                        {
                            title: '食品'
                        },
                        {
                            title: '心脑血管'
                        },
                        {
                            title: '血液'
                        },
                        {
                            title: '眼科'
                        },
                        {
                            title: '疼痛/麻醉'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: '医美'
                        },
                        {
                            title: '肿瘤'
                        },
                        {
                            title: '免疫'
                        },
                        {
                            title: '代谢紊乱；代谢障碍'
                        },
                        {
                            title: '风湿病/炎症'
                        },
                        {
                            title: '药物代谢动力学'
                        },
                        {
                            title: '四期介入性研究'
                        },
                        {
                            title: '四期观察性研究'
                        },
                        {
                            title: '其他'
                        },
                    ]
                },
            ],
        },
        sp: {
            bannerContent: {
                src: require('../assets/service/service3.png'),
                title: '统计编程',
                content: "具有丰富的国内外临床试验的统计编程经验，由具有英、日、韩等多语言的专业人员组成。",
            },
            listData: [
                {
                    title: '统计编程',
                    content: `基于数据递交标准的法规要求，国内外对CDISC的要求正不断增长。在美达临床数据，我们积极地培训公司的员工、拓展和实施改革性方案，遵守CDISC规程以创建标准化的递交数据并积累了丰富的经验。美达临床数据有资格成为您的符合CDISC SDTM要求的数据供应商。我们具有准确的英语、日语等外语能力，可以为您的电子数据提交需求提供无缝、性价比高的解决方案，满足相关监管机构的标准。`,
                    pic: require('../assets/service/3.png'),
                    index: 3
                }
            ],
            helpData: [
                {
                    title: '',
                    list: [
                        {
                            title: '分析数据集(ADS)的创建'
                        },
                        {
                            title: 'CDISC SDTM数据创建和传输',
                        },
                        {
                            title: 'CDISC ADaM数据集创建'
                        },
                        {
                            title: '方案偏离的编程'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: '统计分析人群的编程'
                        },
                        {
                            title: '数据库锁库和传输'
                        },
                        {
                            title: '数据库的质控'
                        },
                        {
                            title: '统计编程'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: '制表/列表/图的编程'
                        },
                        {
                            title: '制表/列表/图的编程的质控'
                        },
                        {
                            title: '临床数据的脱敏'
                        }
                    ]
                },
            ],
            areaData: [
                {
                    title: '',
                    list: [
                        {
                            title: '五官科'
                        },
                        {
                            title: '骨科'
                        },
                        {
                            title: '呼吸系统'
                        },
                        {
                            title: '心理学跟精神'
                        },
                        {
                            title: '抗感染药物/抗病毒药物/疫苗'
                        },
                        {
                            title: '口腔科'
                        },
                        {
                            title: '泌尿系统'
                        },
                        {
                            title: '内分泌'
                        },
                        {
                            title: '胃肠道和肝脏病'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: '生殖学/性健康/妇女健康'
                        },
                        {
                            title: '皮肤病'
                        },
                        {
                            title: '医疗器械和诊断业务'
                        },
                        {
                            title: '神经系统'
                        },
                        {
                            title: '食品'
                        },
                        {
                            title: '心脑血管'
                        },
                        {
                            title: '血液'
                        },
                        {
                            title: '眼科'
                        },
                        {
                            title: '疼痛/麻醉'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: '医美'
                        },
                        {
                            title: '肿瘤'
                        },
                        {
                            title: '免疫'
                        },
                        {
                            title: '代谢紊乱；代谢障碍'
                        },
                        {
                            title: '风湿病/炎症'
                        },
                        {
                            title: '药物代谢动力学'
                        },
                        {
                            title: '四期介入性研究'
                        },
                        {
                            title: '四期观察性研究'
                        },
                        {
                            title: '其他'
                        },
                    ]
                },
            ],
        },
        pharmacovigilance: {
            bannerContent: {
                src: require('../assets/service/service4.png'),
                title: '药物警戒',
                content: "专业的安全性管理，确保药物整个生命周期的安全性。",
            },
            listData: [
                {
                    title: '药物警戒',
                    content: `美达临床数据技术有限公司认识到患者的安全性是每个制药企业所密切关注的。尤其是产品和患者的安全性和产品的价值密切联系在一起，但对安全性承诺并不意味牺牲成本效率。美达临床数据拥有准确的英语、日语、韩语等国语言能力的药物警戒团队及符合安全性信息管理法规要求的标准操作规程（SOP）。我们的经多次优化过的流程、技术及人员能为您提供高质量的服务和节省预算，确保您的药物警戒业务处于行业竞争优势地位。`,
                    pic: require('../assets/service/4.png'),
                    index: 4
                }
            ],
            helpData: [
                {
                    title: '',
                    list: [
                        {
                            title: '重点药品监测'
                        },
                        {
                            title: '药物安全信息管理',
                        },
                        {
                            title: '个例的安全报告'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: '文献检索及处理'
                        },
                        {
                            title: '安全性信号的检出和管理'
                        },
                        {
                            title: '定期安全性更新报告（PSUR）的撰写、翻译及审核'
                        },
                    ]
                }, {
                    title: '',
                    list: [
                        {
                            title: '风险控制计划（RCP）的撰写、翻译及审核'
                        },
                        {
                            title: '风险管理计划（RMP）的撰写、翻译及审核'
                        },
                        {
                            title: '药物安全的医学监查'
                        }
                    ]
                }
            ],
            areaData: [
                {
                    title: '',
                    list: [
                        {
                            title: '五官科'
                        },
                        {
                            title: '骨科'
                        },
                        {
                            title: '呼吸系统'
                        },
                        {
                            title: '心理学跟精神'
                        },
                        {
                            title: '抗感染药物/抗病毒药物/疫苗'
                        },
                        {
                            title: '口腔科'
                        },
                        {
                            title: '泌尿系统'
                        },
                        {
                            title: '内分泌'
                        },
                        {
                            title: '胃肠道和肝脏病'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: '生殖学/性健康/妇女健康'
                        },
                        {
                            title: '皮肤病'
                        },
                        {
                            title: '医疗器械和诊断业务'
                        },
                        {
                            title: '神经系统'
                        },
                        {
                            title: '食品'
                        },
                        {
                            title: '心脑血管'
                        },
                        {
                            title: '血液'
                        },
                        {
                            title: '眼科'
                        },
                        {
                            title: '疼痛/麻醉'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: '医美'
                        },
                        {
                            title: '肿瘤'
                        },
                        {
                            title: '免疫'
                        },
                        {
                            title: '代谢紊乱；代谢障碍'
                        },
                        {
                            title: '风湿病/炎症'
                        },
                        {
                            title: '药物代谢动力学'
                        },
                        {
                            title: '四期介入性研究'
                        },
                        {
                            title: '四期观察性研究'
                        },
                        {
                            title: '其他'
                        },
                    ]
                },
            ],
        },
        cc: {
            bannerContent: {
                src: require('../assets/service/service5.png'),
                title: '呼叫中心',
                content: "专业的安全性管理，确保药物整个生命周期的安全性。",
            },
            listData: [
                {
                    title: '呼叫中心',
                    content: `药品/医疗器械的安全性风险管理是一个持续的过程，贯穿于每一个产品的整个生命周期。临床试验阶段受试者的依从性管理及上市后由于用户（患者）的多样性和复杂性等因素都决定了安全性风险监测是个繁杂且昂贵的过程。通过建立以用户（患者）为中心的呼叫中心电子数据化技术整合系统，搭建企业与用户之间的沟通渠道，提供药品/医疗器械呼叫中心服务，从而协助企业降低研发成本、监测药品/医疗器械的安全性风险、促进公众健康，高质量、高效率、全方位地为客户提供多种服务进而提升用户对企业的包容度、满意度和忠诚度。`,
                    pic: require('../assets/service/5.png'),
                    index: 5
                }
            ],
            helpData: [
                {
                    title: '',
                    list: [
                        {
                            title: '受试者招募支持'
                        },
                        {
                            title: '受试者访视提醒'
                        },
                        {
                            title: '产品安全性信息收集',
                        },
                        {
                            title: '售前/售后服务'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: '调查问卷'
                        },
                        {
                            title: '语音质控'
                        },
                        {
                            title: '知识库管理'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: '用户信息管理'
                        },
                        {
                            title: '项目管理'
                        },
                        {
                            title: '数据统计分析及报告'
                        }
                    ]
                }
            ],
            areaData: [
                {
                    title: '',
                    list: [
                        {
                            title: '五官科'
                        },
                        {
                            title: '骨科'
                        },
                        {
                            title: '呼吸系统'
                        },
                        {
                            title: '心理学跟精神'
                        },
                        {
                            title: '抗感染药物/抗病毒药物/疫苗'
                        },
                        {
                            title: '口腔科'
                        },
                        {
                            title: '泌尿系统'
                        },
                        {
                            title: '内分泌'
                        },
                        {
                            title: '胃肠道和肝脏病'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: '生殖学/性健康/妇女健康'
                        },
                        {
                            title: '皮肤病'
                        },
                        {
                            title: '医疗器械和诊断业务'
                        },
                        {
                            title: '神经系统'
                        },
                        {
                            title: '食品'
                        },
                        {
                            title: '心脑血管'
                        },
                        {
                            title: '血液'
                        },
                        {
                            title: '眼科'
                        },
                        {
                            title: '疼痛/麻醉'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: '医美'
                        },
                        {
                            title: '肿瘤'
                        },
                        {
                            title: '免疫'
                        },
                        {
                            title: '代谢紊乱；代谢障碍'
                        },
                        {
                            title: '风湿病/炎症'
                        },
                        {
                            title: '药物代谢动力学'
                        },
                        {
                            title: '四期介入性研究'
                        },
                        {
                            title: '四期观察性研究'
                        },
                        {
                            title: '其他'
                        },
                    ]
                },
            ],
        },
    },
    en: {
        dm: {
            bannerContent: {
                src: require('../assets/service/service1.png'),
                title: 'Data Management',
                content: "With rich experience in data management of clinical trials at home and abroad, it is composed of professionals with English, Japanese, Korean and other languages.",
            },
            listData: [
                {
                    title: 'Data Management',
                    content: `The purpose of data management is to ensure the reliability, completeness and accuracy of data obtained in clinical trials and that the data are reasonable before statistical analysis. Quality comes from design, and the reliability of data is firstly based on the scientific design of trial protocols and case report forms, and secondly, it needs the guarantee of perfect quality management system and standardized data management, while the data management personnel must be strictly trained in GCP and data management related regulations, and the electronic data collection system or data management system applied to data collection and data management must be validated and meet the requirements of the The electronic data capture system or data management system used for data capture and data management must be validated and meet the requirements of FDA 21 CFR part 11 and NMPA "Technical Guidelines for Electronic Data Capture in Clinical Trials". Meta Clinical Data's data management team strictly follows the ICH-GCP, CDISC standards and relevant regulations for clinical trials to provide professional and high-quality services to our clients, and has rich experience in clinical trial data management in Europe, the United States, Japan and China. Key team members have excellent communication skills in English, Japanese and other languages, and are able to communicate effectively with domestic and international clients.`,
                    pic: require('../assets/service/1.png'),
                    index: 1
                }
            ],
            helpData: [
                {
                    title: '',
                    list: [
                        {
                            title: 'Data Management Consultation'
                        },
                        {
                            title: 'CRF Design/Review'
                        },
                        {
                            title: 'Database Design and Set-up'
                        },
                        {
                            title: 'Data Management Plan and Report Development'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: 'Data Validation Plan Development'
                        },
                        {
                            title: 'Data Entry and Verification'
                        },
                        {
                            title: 'Data Validation and Cleaning'
                        },
                        {
                            title: 'Query Generation/Resolution'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: 'Serious Adverse Event Reconciliation'
                        },
                        {
                            title: 'External Data Reconciliation'
                        },
                        {
                            title: 'Medical Coding'
                        },
                        {
                            title: 'Data Review Meeting Support'
                        },
                        {
                            title: 'Audit of Data Quality'
                        }
                    ]
                }
            ],
            areaData: [
                {
                    title: '',
                    list: [
                        {
                            title: 'Otolaryngology'
                        },
                        {
                            title: 'Musculoskeletal'
                        },
                        {
                            title: 'Respiratory system'
                        },
                        {
                            title: 'Psychology/Psychiatry'
                        },
                        {
                            title: 'Anti-Infectives / Antivirals / Vaccination'
                        },
                        {
                            title: 'Department of Stomatology'
                        },
                        {
                            title: 'Urinary system'
                        },
                        {
                            title: 'Endocrine'
                        },
                        {
                            title: 'Gastrointestinal / Hepatology'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: "Genitourinary / Sexual Health / Women's Health"
                        },
                        {
                            title: 'Dermatology'
                        },
                        {
                            title: 'Devices and Diagnostics'
                        },
                        {
                            title: 'Neurology / CNS'
                        },
                        {
                            title: 'Food'
                        },
                        {
                            title: 'Cardiovascular'
                        },
                        {
                            title: 'Hematology'
                        },
                        {
                            title: 'Ophthalmology'
                        },
                        {
                            title: 'Pain/Anesthesia'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: 'Aesthetic medicine'
                        },
                        {
                            title: 'Oncology'
                        },
                        {
                            title: 'Immunological'
                        },
                        {
                            title: 'Metabolic Disorders'
                        },
                        {
                            title: 'Rheumatology / Inflammation'
                        },
                        {
                            title: 'Pharmacokinetic'
                        },
                        {
                            title: 'Phase IV – IND'
                        },
                        {
                            title: 'Phase IV – Observational'
                        },
                        {
                            title: 'Other'
                        },
                    ]
                },
            ],
        },
        biostatistics: {
            bannerContent: {
                src: require('../assets/service/service2.png'),
                title: 'Biostatistics',
                content: "He has rich biostatistical experience in clinical trials at home and abroad, and is composed of professionals with English, Japanese, Korean and other languages.",
            },
            listData: [
                {
                    title: 'Biostatistics',
                    content: `The biostatistics team consists of industry-renowned statistical experts and a number of senior statisticians, providing professional statistical support in every step of the process, from study design, implementation, to delivery of study results. We have a comprehensive quality assurance system and standard operating procedures, and are familiar with and comply with the requirements of statistical regulations, and are committed to providing high-quality and comprehensive statistical services for pharmaceutical research and development.
                    Our statistical team has a wealth of experience, including:                    
<p style="color: #435ba1">-Innovative drug 
-Bioequivalence studies 
-Data Monitoring Committee (DMC) support
-Observational Research/Non-interventional Studies
-Biosimilars
-Medical devices<p/>`,
                    pic: require('../assets/service/2.png'),
                    index: 2
                }
            ],
            helpData: [
                {
                    title: '',
                    list: [
                        {
                            title: 'Statistical Consulting'
                        },
                        {
                            title: 'Protocol Development',
                        },
                        {
                            title: 'Randomization Code Generation'
                        },
                        {
                            title: 'CRF Review'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: 'Data Validation Plans Review'
                        },
                        {
                            title: 'Statistical Analysis Plan Development'
                        },
                        {
                            title: 'TLF Programming'
                        },
                        {
                            title: 'Table, Listing, Figures (TLF) Mock-up Shell Development'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: 'Statistical Analysis'
                        },
                        {
                            title: 'Statistical Monitoring'
                        },
                        {
                            title: 'CSR Review'
                        },
                        {
                            title: 'Data Monitoring Committee (DMC) Support'
                        },
                        {
                            title: 'Data Review Prior Database Lock'
                        },
                        {
                            title: 'Un-blinding'
                        }
                    ]
                }
            ],
            areaData: [
                {
                    title: '',
                    list: [
                        {
                            title: 'Otolaryngology'
                        },
                        {
                            title: 'Musculoskeletal'
                        },
                        {
                            title: 'Respiratory system'
                        },
                        {
                            title: 'Psychology/Psychiatry'
                        },
                        {
                            title: 'Anti-Infectives / Antivirals / Vaccination'
                        },
                        {
                            title: 'Department of Stomatology'
                        },
                        {
                            title: 'Urinary system'
                        },
                        {
                            title: 'Endocrine'
                        },
                        {
                            title: 'Gastrointestinal / Hepatology'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: "Genitourinary / Sexual Health / Women's Health"
                        },
                        {
                            title: 'Dermatology'
                        },
                        {
                            title: 'Devices and Diagnostics'
                        },
                        {
                            title: 'Neurology / CNS'
                        },
                        {
                            title: 'Food'
                        },
                        {
                            title: 'Cardiovascular'
                        },
                        {
                            title: 'Hematology'
                        },
                        {
                            title: 'Ophthalmology'
                        },
                        {
                            title: 'Pain/Anesthesia'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: 'Aesthetic medicine'
                        },
                        {
                            title: 'Oncology'
                        },
                        {
                            title: 'Immunological'
                        },
                        {
                            title: 'Metabolic Disorders'
                        },
                        {
                            title: 'Rheumatology / Inflammation'
                        },
                        {
                            title: 'Pharmacokinetic'
                        },
                        {
                            title: 'Phase IV – IND'
                        },
                        {
                            title: 'Phase IV – Observational'
                        },
                        {
                            title: 'Other'
                        },
                    ]
                },
            ],
        },
        sp: {
            bannerContent: {
                src: require('../assets/service/service3.png'),
                title: 'Statistical Programming',
                content: "He has rich experience in statistical programming of clinical trials at home and abroad, and is composed of professionals with English, Japanese, Korean and other languages.",
            },
            listData: [
                {
                    title: 'Statistical Programming',
                    content: `CDISC requirements are growing both domestically and internationally based on regulatory requirements for data submission standards. At Midas Clinical Data, we are actively training our staff, expanding and implementing transformative programs, complying with CDISC protocols to create standardized submissions and gaining experience. Meta Clinical Data is qualified to be your CDISC SDTM-compliant data provider. With accurate foreign language skills in English and Japanese, we can provide a seamless, cost-effective solution to your electronic data submission needs that meets the standards of the relevant regulatory agencies.`,
                    pic: require('../assets/service/3.png'),
                    index: 3
                }
            ],
            helpData: [
                {
                    title: '',
                    list: [
                        {
                            title: 'Analysis Data Sets (ADS) Development'
                        },
                        {
                            title: 'CDISC SDTM Mapping and Transfer',
                        },
                        {
                            title: 'CDISC ADaM Dataset Development'
                        },
                        {
                            title: 'Programming of Protocol Deviations'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: 'Programming of Analysis Populations'
                        },
                        {
                            title: 'Database Lock and Transfer'
                        },
                        {
                            title: 'Quality Control of Database'
                        },
                        {
                            title: 'Statistical Analysis Programming'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: 'TLF Programming'
                        },
                        {
                            title: 'Quality Control of TLF programming'
                        },
                        {
                            title: 'Data Anonymization of Clinical Research'
                        }
                    ]
                }
            ],
            areaData: [
                {
                    title: '',
                    list: [
                        {
                            title: 'Otolaryngology'
                        },
                        {
                            title: 'Musculoskeletal'
                        },
                        {
                            title: 'Respiratory system'
                        },
                        {
                            title: 'Psychology/Psychiatry'
                        },
                        {
                            title: 'Anti-Infectives / Antivirals / Vaccination'
                        },
                        {
                            title: 'Department of Stomatology'
                        },
                        {
                            title: 'Urinary system'
                        },
                        {
                            title: 'Endocrine'
                        },
                        {
                            title: 'Gastrointestinal / Hepatology'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: "Genitourinary / Sexual Health / Women's Health"
                        },
                        {
                            title: 'Dermatology'
                        },
                        {
                            title: 'Devices and Diagnostics'
                        },
                        {
                            title: 'Neurology / CNS'
                        },
                        {
                            title: 'Food'
                        },
                        {
                            title: 'Cardiovascular'
                        },
                        {
                            title: 'Hematology'
                        },
                        {
                            title: 'Ophthalmology'
                        },
                        {
                            title: 'Pain/Anesthesia'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: 'Aesthetic medicine'
                        },
                        {
                            title: 'Oncology'
                        },
                        {
                            title: 'Immunological'
                        },
                        {
                            title: 'Metabolic Disorders'
                        },
                        {
                            title: 'Rheumatology / Inflammation'
                        },
                        {
                            title: 'Pharmacokinetic'
                        },
                        {
                            title: 'Phase IV – IND'
                        },
                        {
                            title: 'Phase IV – Observational'
                        },
                        {
                            title: 'Other'
                        },
                    ]
                },
            ],
        },
        pharmacovigilance: {
            bannerContent: {
                src: require('../assets/service/service4.png'),
                title: 'Pharmacovigilance',
                content: "Professional safety management ensures the safety of the drug throughout its life cycle.",
            },
            listData: [
                {
                    title: 'Pharmacovigilance',
                    content: `Meta Clinical understands that patient safety is at the main focus of every company. Ultimately, product and patient safety are tied to product value, but a commitment to safety shouldn't mean sacrificing cost-efficiency. Meta Clinical has a professional pharmacovigilance team with multilingual capability, and SOPs meet global/domestic regulatory requirements of safety information management. Our optimized processes, technology and resources will ensure the quality, fit your budget，and help you gain competitive advantage in the industry. `,
                    pic: require('../assets/service/4.png'),
                    index: 4
                }
            ],
            helpData: [
                {
                    title: '',
                    list: [
                        {
                            title: 'Intensive Drug Monitoring'
                        },
                        {
                            title: 'Drug Safety Information Management',
                        },
                        {
                            title: 'Individual Case Safety Report'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: 'Literature Searching and Processing'
                        },
                        {
                            title: 'Signal Detection and Management'
                        },
                        {
                            title: 'Periodic Safety Update Reports'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: 'Risk Control Plans Development'
                        },
                        {
                            title: 'Risk Management Plans Development'
                        },
                        {
                            title: 'Medical Review'
                        }
                    ]
                }
            ],
            areaData: [
                {
                    title: '',
                    list: [
                        {
                            title: 'Otolaryngology'
                        },
                        {
                            title: 'Musculoskeletal'
                        },
                        {
                            title: 'Respiratory system'
                        },
                        {
                            title: 'Psychology/Psychiatry'
                        },
                        {
                            title: 'Anti-Infectives / Antivirals / Vaccination'
                        },
                        {
                            title: 'Department of Stomatology'
                        },
                        {
                            title: 'Urinary system'
                        },
                        {
                            title: 'Endocrine'
                        },
                        {
                            title: 'Gastrointestinal / Hepatology'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: "Genitourinary / Sexual Health / Women's Health"
                        },
                        {
                            title: 'Dermatology'
                        },
                        {
                            title: 'Devices and Diagnostics'
                        },
                        {
                            title: 'Neurology / CNS'
                        },
                        {
                            title: 'Food'
                        },
                        {
                            title: 'Cardiovascular'
                        },
                        {
                            title: 'Hematology'
                        },
                        {
                            title: 'Ophthalmology'
                        },
                        {
                            title: 'Pain/Anesthesia'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: 'Aesthetic medicine'
                        },
                        {
                            title: 'Oncology'
                        },
                        {
                            title: 'Immunological'
                        },
                        {
                            title: 'Metabolic Disorders'
                        },
                        {
                            title: 'Rheumatology / Inflammation'
                        },
                        {
                            title: 'Pharmacokinetic'
                        },
                        {
                            title: 'Phase IV – IND'
                        },
                        {
                            title: 'Phase IV – Observational'
                        },
                        {
                            title: 'Other'
                        },
                    ]
                },
            ],
        },
        cc: {
            bannerContent: {
                src: require('../assets/service/service5.png'),
                title: 'Call Center',
                content: "Professional safety management ensures the safety of the drug throughout its life cycle.",
            },
            listData: [
                {
                    title: 'Call Center',
                    content: `Drug and medical device safety risk management is an ongoing process that stretches the entire life cycle of a product. Compliance management of subjects during the clinical development stage as well as the diversity and complexity users (patients) inevitably bring to the table post-market mean that safety risk monitoring is a complex and expensive process.
By establishing an Electronic Data Integration (EDI) call center you create a communication channel between you and your patients that will help drive your R&D costs down and assist you to monitor your products’ safety risks with more efficiency and accuracy, all whilst simultaneously promoting public health. Moreover, providing your patients with a variety of high-quality, efficient, all-round services will enhance their experience with you, leading to higher satisfaction rates and a stronger sense of loyalty towards your brand.`,
                    pic: require('../assets/service/5.png'),
                    index: 5
                }
            ],
            helpData: [
                {
                    title: '',
                    list: [
                        {
                            title: 'Support Subject Enrolment'
                        },
                        {
                            title: 'Subject Visit Reminder'
                        },
                        {
                            title: 'Product Safety Information Collection',
                        },
                        {
                            title: 'Pre-sales/After-sales Service'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: 'Survey'
                        },
                        {
                            title: 'Voice Quality Control'
                        },
                        {
                            title: 'Knowledge Base Managemen'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: 'User Information Management'
                        },
                        {
                            title: 'Project Management'
                        },
                        {
                            title: 'Data Analysis and Report'
                        }
                    ]
                }
            ],
            areaData: [
                {
                    title: '',
                    list: [
                        {
                            title: 'Otolaryngology'
                        },
                        {
                            title: 'Musculoskeletal'
                        },
                        {
                            title: 'Respiratory system'
                        },
                        {
                            title: 'Psychology/Psychiatry'
                        },
                        {
                            title: 'Anti-Infectives / Antivirals / Vaccination'
                        },
                        {
                            title: 'Department of Stomatology'
                        },
                        {
                            title: 'Urinary system'
                        },
                        {
                            title: 'Endocrine'
                        },
                        {
                            title: 'Gastrointestinal / Hepatology'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: "Genitourinary / Sexual Health / Women's Health"
                        },
                        {
                            title: 'Dermatology'
                        },
                        {
                            title: 'Devices and Diagnostics'
                        },
                        {
                            title: 'Neurology / CNS'
                        },
                        {
                            title: 'Food'
                        },
                        {
                            title: 'Cardiovascular'
                        },
                        {
                            title: 'Hematology'
                        },
                        {
                            title: 'Ophthalmology'
                        },
                        {
                            title: 'Pain/Anesthesia'
                        },
                    ]
                },
                {
                    title: '',
                    list: [
                        {
                            title: 'Aesthetic medicine'
                        },
                        {
                            title: 'Oncology'
                        },
                        {
                            title: 'Immunological'
                        },
                        {
                            title: 'Metabolic Disorders'
                        },
                        {
                            title: 'Rheumatology / Inflammation'
                        },
                        {
                            title: 'Pharmacokinetic'
                        },
                        {
                            title: 'Phase IV – IND'
                        },
                        {
                            title: 'Phase IV – Observational'
                        },
                        {
                            title: 'Other'
                        },
                    ]
                },
            ],
        },
    }
};

export default serviceData[lang]
